export default "__VITE_ASSET__DNpcOR3Z__"